export default __webpack_public_path__ + "static/media/img-slider-layout.196e44c4.png";